class LabelRepel1D {
    constructor() {
        this._labels = new Map();
        this._labelBox = new Map();
        this._order = null;
    }

    setLabelBox(id, box) {
        const { min, max } = box;
        box = { min, max };
        this._labelBox.set(id, box);
    }

    removeLabelBox(id) {
        this._labelBox.delete(id);
    }

    setLabelPosition(id, position) {
        this._labels.set(id, { position, push: 0 });
        this._order = null;
    }

    removeLabel(id) {
        if (this._labels.has(id)) {
            this._labels.delete(id);
            this._order = null;
        }
    }

    getLabelPush(id) {
        return this._labels.get(id).push;
    }

    calculate() {
        if (!this._order) {
            const labelCenter = new Map();
            for (let [id, data] of this._labels) {
                let center = 0;
                if (this._labelBox.has(id)) {
                    const { min, max } = this._labelBox.get(id);
                    center = (min+max)*0.5;
                }

                labelCenter.set(id, data.position+center);
            }

            this._order = Array.from(this._labels.keys());
            this._order.sort((id1, id2) => labelCenter.get(id1)-labelCenter.get(id2));
        }

        for (let [id, data] of this._labels) {
            data.push = 0;
        }

        let pushed = false;

        const newPositions = new Map();

        const getBlockDistance = (block1, block2) => {
            let block1HighId = block1[block1.length-1];
            let block2LowId = block2[0];
            let off1Max = this._labelBox.has(block1HighId) ? this._labelBox.get(block1HighId).max : 0;
            let off2Min = this._labelBox.has(block2LowId) ? this._labelBox.get(block2LowId).min : 0;
            let block1HighPos = newPositions.get(block1HighId)+off1Max;
            let block2LowPos = newPositions.get(block2LowId)+off2Min;
            return block2LowPos-block1HighPos;
        };

        for (let [id, data] of this._labels) {
            newPositions.set(id, data.position);
        }

        let blocks = [];
        for (let id of this._order) {
            blocks.push([id]);
        }

        let keepPushing = true;
        while (keepPushing) {
            keepPushing = false;

            const nextBlocks = [];

            for (let b2 = 0; b2 < blocks.length; b2++) {
                let b1 = b2-1;
                const block1 = blocks[b1], block2 = blocks[b2];

                if (b1 >= 0 && getBlockDistance(block1, block2) < 0) {
                    const nextBlock = nextBlocks[nextBlocks.length-1];

                    for (let id2 of block2) {
                        nextBlock.push(id2);
                    }

                    let blockCenter = 0, blockSize = 0;

                    for (let id of nextBlock) {
                        let size = 0, center = 0;
                        if (this._labelBox.has(id)) {
                            const { min, max } = this._labelBox.get(id);
                            size = max-min;
                            center = (min+max)*0.5;
                        }

                        blockCenter += (this._labels.get(id).position+center)*size;
                        blockSize += size;
                    }
                    blockCenter /= blockSize;

                    let blockMin = blockCenter-blockSize*0.5;
                    let labelMin = blockMin;
                    for (let id of nextBlock) {
                        let min = 0, max = 0;
                        if (this._labelBox.has(id)) {
                            ({ min, max } = this._labelBox.get(id));
                        }

                        let labelPos = labelMin-min;
                        newPositions.set(id, labelPos);

                        labelMin = labelPos+max;
                    }

                    keepPushing = true;
                    pushed = true;
                } else {
                    const nextBlock = block2.slice();
                    nextBlocks.push(nextBlock);
                }
            }

            blocks = nextBlocks;
        }

        for (let [id, data] of this._labels) {
            data.push = newPositions.get(id)-data.position;
        }

        return pushed;
    }
}

export default LabelRepel1D;
